import { render } from "./update_yunke.vue?vue&type=template&id=60eee4ac"
import script from "./update_yunke.vue?vue&type=script&lang=js"
export * from "./update_yunke.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__